import _difference from 'lodash/difference'
import _groupBy from 'lodash/groupBy'
import FactoryLevel from 'frontend/helpers/factoryLevel'
import { createFilterOption } from 'frontend/helpers/filterSelectorUtils'
import { FALLBACK_LANGUAGE, getLanguage } from 'frontcore/i18n'
import { store } from 'frontend/store/store'

export function getPerimeterPathString (perimeter) {
  if (perimeter === null || perimeter === undefined) return ''
  return getPerimeterPath(perimeter).join(' | ')
}

export function getPerimeterPath (perimeter) {
  const perimeterNames = []
  if (perimeter === null || perimeter === undefined) return []
  do {
    perimeterNames.push(perimeter.name)
    const parent = typeof perimeter.parent === 'number' ?
      store.getters.getPerimeterById(perimeter.parent) :
      perimeter.parent
    perimeter = parent
  } while (perimeter !== null && perimeter !== undefined)
  return perimeterNames.reverse()
}

export function getOrdererLevelArray (initialArray, orderedArray, id, level) {
  const branches = initialArray
    .filter(branch => { return branch.parent === id })
    .sort(sortPatternAlphabetically)
  branches.forEach(branch => {
    branch['level'] = level
    orderedArray.push(branch)
    getOrdererLevelArray(initialArray, orderedArray, branch.id, level +1 )
  })
}

export function sortPatternAlphabetically (pattern1, pattern2) {
  if (!pattern1 || !pattern2) return 0
  if (pattern1.name && pattern2.name) {
    return patternsHasName(pattern1, pattern2)
  }
  if (pattern1.localized && pattern2.localized) {
    return patternsHasLocalized(pattern1, pattern2)
  }
  return 0
}

function patternsHasName (pattern1, pattern2) {
  if (pattern1.name.toLowerCase() > pattern2.name.toLowerCase()) { return 1 }
  if (pattern1.name.toLowerCase() < pattern2.name.toLowerCase()) { return -1 }
}

function patternsHasLocalized (pattern1, pattern2) {
  const localizedPattern1 = pattern1.localized.hasOwnProperty(getLanguage()) ? pattern1.localized[getLanguage()] : pattern1.localized[FALLBACK_LANGUAGE]
  const localizedPattern2 = pattern2.localized.hasOwnProperty(getLanguage()) ? pattern2.localized[getLanguage()] : pattern2.localized[FALLBACK_LANGUAGE]
  if (localizedPattern1?.toLowerCase() > localizedPattern2?.toLowerCase()) { return 1 }
  if (localizedPattern1?.toLowerCase() < localizedPattern2?.toLowerCase()) { return -1 }
}

export function getFilterOrphans (context, selectedPerimeters, options) {
  const perimeterOptions = options
  const optionsIds = options.filter(item => item.value).map(item => item.value)
  const orphans = _difference(selectedPerimeters, optionsIds)
  if (orphans.length) {
    const perimeters = []
    orphans.forEach(id => {
      const factoryLevel = FactoryLevel.getFactoryLevelForPerimeterId(id)
      perimeters.push({
        item: factoryLevel.items.find(item => item.id === id),
        level: factoryLevel.name,
      })
    })
    perimeterOptions.push({ header: context.$t('common.messages.others') })
    perimeters.forEach(perimeter => {
      perimeterOptions.push(
        createFilterOption({
          value: perimeter.item.id,
          text: perimeter.item.name,
          group: perimeter.level.name,
        }))
    })
  }
  return perimeterOptions
}

export function getFilterOptionsGroupByParents (permissionChecker, caller) {
  const factoryLevels = FactoryLevel.getLowestLevel(caller)

  // use factoryLevels.filteredItems to take into account the selected perimeters in caminito
  const grouped = _groupBy(factoryLevels.filteredItems, 'parent')
  const filteredGrouped = Object.keys(grouped).filter(
    (key) => key !== 'null'
  ).reduce(
    (cur, key) => { return Object.assign(cur, { [key]: grouped[key] })}, {}
  )
  let perimeterOptions = []

  for (const key in filteredGrouped) {
    const parent = parseInt(key)
    const optionsFiltered = filteredGrouped[key]
      .filter(perimeter => permissionChecker(perimeter.id))
      .map(perimeter => createFilterOption({
        value: perimeter.id,
        text: perimeter.name,
        group: store.getters.getPerimeterById(parent).name,
      }))

    if (optionsFiltered.length) {
      perimeterOptions.push({ header: store.getters.getPerimeterById(parent).name })
      perimeterOptions = perimeterOptions.concat(optionsFiltered)
    }
  }

  return perimeterOptions
}
